/**
 * What: Canonical forward-looking treatment metadata for Shopify-authored studies.
 * Transport / data-flow: Shared Zod contract used by Shopify packet producers and Web/Shopify packet consumers.
 *
 */
import * as z from 'zod';
export const SHOPIFY_AUTHORED_TREATMENT_TYPES = [
    'claim',
    'value_proposition',
    'description',
    'usage_experience',
    'ingredient_proof',
    'price',
    'promotion_mechanic',
    'image_creative',
];
export const shopifyAuthoredTreatmentTypeSchema = z.enum(SHOPIFY_AUTHORED_TREATMENT_TYPES);
export const shopifyTreatmentCountSchema = z.number().int().nonnegative();
/** Why: forward metadata is useful only as a complete pair; historical packets carry neither field. */
export const shopifyTreatmentMetadataSchema = z.union([
    z.object({
        treatmentType: shopifyAuthoredTreatmentTypeSchema,
        treatmentCount: shopifyTreatmentCountSchema,
    }),
    z.object({
        treatmentType: z.undefined().optional(),
        treatmentCount: z.undefined().optional(),
    }),
]);
//# sourceMappingURL=shopify-treatment-metadata.js.map